import ReactECharts from "echarts-for-react";
import { useSelector } from "react-redux";
import { PARAMS } from "../util/GlobalConstants";

export const legendIcons = {
  circle: "circle",
  rect: "rect",
  roundRect: "roundRect",
  triangle: "triangle",
  diamond: "diamond",
  pin: "pin",
  arrow: "arrow",
  none: "none",
};
export const legendLeftTypes = {
  left: "left",
  center: "center",
  right: "right",
};
export const labelFotmatterTypes = {
  seriesName: "{a}",
  itemName: "{b}",
  itemValue: "{c}",
  percent: "{d}",
};
export const labelPositionTypes = {
  outside: "outside",
  inside: "inside",
  center: "center",
};
export const labelAlingToTypes = {
  none: "none",
  labelLine: "labelLine",
  edge: "edge",
};

const PieChart = ({
  title = "",
  subtitle = "",
  data = [],
  legendData = [],
  nameItems = "",
  onReady,
  onClick,
  onLegendSelectChanged,
  style = { height: 400 },
  showTooltip = true,
  legendLeft = "left",
  legendShow = true,
  labelFormatter = "{b}",
  labelLineLenght = "3%",
  emphasisDisabled = false,
  radius = "65%",
  center = ["50%", "60%"],
  legendItemWidth = 25,
  legendSelectedMode = true,
  legendIcon = "roundRect",
  labelPosition = "outside",
  labelEdgeDistance = "25%",
  labelAlignTo = "none",
  cursorType = "pointer",
  modern = false,
  centerLabel = "",
  colors = null,
  labelInside = false,
}) => {
  const theme = useSelector((state) => state.theme.currentTheme);
  const textColor = theme === PARAMS.theme.light ? "#222b45" : "#fff";
  const mutedColor = theme === PARAMS.theme.light ? "#8f9bb3" : "#a9b4cf";
  const colorPalette = colors || [
    "#588aff",
    "#2de69a",
    "#42abfe",
    "#ffc84c",
    "#fe708c",
  ];
  const total = data.reduce((sum, d) => sum + (d.value || 0), 0);

  // Modern donut overrides — only applied when modern=true
  const modernSeries = modern
    ? {
        radius: ["54%", "76%"],
        center: ["50%", "52%"],
        padAngle: 4,
        itemStyle: {
          borderRadius: 10,
          borderColor: "transparent",
        },
        label: labelInside
          ? {
              show: true,
              position: "inside",
              formatter: "{d}%",
              color: "#fff",
              fontSize: 13,
              fontWeight: 700,
            }
          : {
              show: true,
              position: "outside",
              formatter: "{b}\n{d}%",
              color: textColor,
              lineHeight: 16,
            },
        labelLine: { show: !labelInside, length: 12, length2: 12 },
        emphasis: {
          scale: true,
          scaleSize: 6,
          itemStyle: {
            shadowBlur: 18,
            shadowColor: "rgba(0, 0, 0, 0.35)",
          },
        },
      }
    : {};

  const option = {
    title: {
      show: title !== "",
      text: title,
      subtext: subtitle,
      x: "center",
      textStyle: {
        color: textColor,
      },
      subtextStyle: {
        color: textColor,
      },
    },
    tooltip: {
      show: showTooltip,
      trigger: "item",
      formatter: "{a} <br/>{b} : {c} ({d}%)",
      backgroundColor: "rgba(22, 22, 45, 0.8)",
      textStyle: {
        color: "#fff",
      },
      borderWidth: 0,
    },
    legend: {
      show: legendShow,
      orient: modern ? "horizontal" : "vertical",
      left: modern ? "center" : legendLeft,
      bottom: modern ? 0 : undefined,
      data: legendData,
      textStyle: {
        color: textColor,
      },
      itemWidth: legendItemWidth,
      selectedMode: legendSelectedMode,
      icon: modern ? "circle" : legendIcon,
    },
    graphic:
      modern && total > 0
        ? [
            {
              type: "text",
              left: "center",
              top: "44%",
              style: {
                text: String(total),
                textAlign: "center",
                fill: textColor,
                fontSize: 30,
                fontWeight: 800,
              },
            },
            {
              type: "text",
              left: "center",
              top: "55%",
              style: {
                text: (centerLabel || "").toUpperCase(),
                textAlign: "center",
                fill: mutedColor,
                fontSize: 11,
                fontWeight: 600,
              },
            },
          ]
        : undefined,
    series: [
      {
        name: nameItems,
        type: "pie",
        radius: radius,
        center: center,
        data: data,
        cursor: cursorType,
        emphasis: {
          disabled: emphasisDisabled,
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
        label: {
          formatter: labelFormatter,
          position: labelPosition,
          color: textColor,
          edgeDistance: labelEdgeDistance,
          alignTo: labelAlignTo,
        },
        labelLine: {
          length: labelLineLenght,
        },
        ...modernSeries,
      },
    ],
    color: colorPalette,
  };
  function onChartReady(echarts) {
    if (typeof onReady === "function") onReady(echarts);
  }
  function onChartClick(param, echarts) {
    if (typeof onClick === "function") onClick(param, echarts);
  }
  function onChartLegendSelectChanged(param, echarts) {
    if (typeof onLegendSelectChanged === "function")
      onLegendSelectChanged(param, echarts);
  }
  return (
    data.length > 0 &&
    legendData.length > 0 &&
    data.length === legendData.length && (
      <ReactECharts
        option={option}
        style={style}
        onChartReady={onChartReady}
        onEvents={{
          click: onChartClick,
          legendselectchanged: onChartLegendSelectChanged,
        }}
      />
    )
  );
};

export default PieChart;
